export default __webpack_public_path__ + "static/media/145.a2835316.png";